import { useState } from 'react';
import { toast } from 'sonner';
import { ShieldAlert } from 'lucide-react';
import api from '../../lib/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const store = (data) => {
  sessionStorage.setItem('access_token', data.access_token);
  sessionStorage.setItem('organization', JSON.stringify(data.organization));
};

export const leavePlatform = async (navigate) => {
  try { const { data } = await api.post('/api/auth/platform-session/leave'); store(data); toast.success(`Back in ${data.organization.name}`); navigate('/dashboard'); }
  catch (e) { toast.error(e.response?.data?.detail || 'Could not switch back'); }
};

// Shown on /platform-admin when the current session is a practice (tenant) session.
export const NotPlatformPanel = ({ who, onEntered, navigate }) => {
  const [busy, setBusy] = useState(false);
  const enter = async () => {
    setBusy(true);
    try { const { data } = await api.post('/api/auth/platform-session/enter'); store(data); toast.success('Switched to the platform console'); onEntered(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not switch to the platform console'); } finally { setBusy(false); }
  };
  return (
    <Card data-testid="platform-not-admin"><CardHeader>
      <CardTitle className="flex items-center gap-2"><ShieldAlert className="h-5 w-5" />
        {who.is_platform_admin ? "You're signed in to your practice" : "This account isn't a platform administrator"}</CardTitle>
      <CardDescription>{who.is_platform_admin
        ? 'Your account is also a platform administrator. Switch this tab to the platform console (re-confirm your password and code). You can switch back to your practice at any time.'
        : 'The platform console is only for platform administrators. Ask an existing platform administrator, or add your email to PLATFORM_ADMIN_EMAILS on the server and redeploy.'}</CardDescription></CardHeader>
      <CardContent className="flex flex-wrap gap-2">
        {who.is_platform_admin && <Button onClick={enter} disabled={busy} data-testid="platform-enter-console">Switch to platform console</Button>}
        <Button variant="outline" onClick={() => navigate('/dashboard')} data-testid="platform-go-dashboard">Go to my practice</Button>
      </CardContent></Card>
  );
};
